import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { ToastComponent } from '@ui/toast/toast.component';

export interface ToastData {
  message: string;
  close: boolean;
}

@Injectable()
export class ToastService {

  constructor(private snackBar: MatSnackBar) { }

  public success(data: ToastData) {
    this.snackBar.openFromComponent(ToastComponent, {
      data,
      duration: 3000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: 'toast-success'
    });
  }
}
